import logger from "./Logger";

const iconByType = {
    'BodyOfWater': 'water',
    'WaterFeature': 'fountain',
    'Pump': 'pump'
};
const iconByDeviceType = {
    "ChlorineSensor": "sensor-cl",
    'Pump': 'pump',
    'Filter': 'filter',
    'Heater': 'flame',
    'ActuatorThreeWay': 'actuator3',
    'ActuatorTwoWay': 'actuator2',
    'Blower': 'chart-bubble-material-community',
    'T': 'split',
    'Cleaner': 'cleaner',
    'FlowSwitch': 'flowsensor',
    'Light': 'sun',
    'SaltCell': 'salt-cell',
    'Thermistor': 'temperature-sensor',
    'ManualValve': 'actuator2',
    'PHProbe': 'sensor-ph',
    'ORPProbe': 'sensor-orp',
    'ChemicalPump': 'laboratory-glassware',
    'SolarHeater': 'solar-heater',
    'Chiller': 'snowflake',
    'HeatPump': 'fan',
    'PressureSensor': 'gauge',
    'PoolCover': 'pool-cover',
    'Cover': 'pool-cover',
    'Ozonator': 'ozonator',
    'UvSanitizer': 'uv',
    'Button': 'gesture-tap-button',
    'ChemistryController': 'vials',
    'FillSwitch': 'water-pump',
    'FlowRelay': 'source-branch-sync', // water-sync is probabaly better, but probably need to update icon package
    'AutoFill': 'autofill',
};

export class GraphIcon {
    static getNodeIconName(node) {
        if (!node)
            return null;
        if (iconByType[node.type]) {
            return iconByType[node.type];
        }
        if (iconByDeviceType[node.DeviceType]) {
            return iconByDeviceType[node.DeviceType];
        }
        if (node.entity && iconByDeviceType[node.entity.DeviceType]) {
            return iconByDeviceType[node.entity.DeviceType];
        }
        logger.info("[Utils.Icon] GraphIcon() No icon defined for node:", node);
        
        return null;
    }
}